"use strict";
exports.__esModule = true;
exports.reqArgs = void 0;
function reqArgs(tokens, d) {
    if (typeof d === 'undefined') {
        console.warn('context not provided');
        return new Proxy({}, {
            get: function () { return ''; }
        });
    }
    if (typeof d !== 'object') {
        console.warn('incorect context: ${JSON.stringify(d)}');
        return d;
    }
    tokens.forEach(function (token) {
        if (typeof d[token] === 'undefined') {
            console.warn("context ".concat(JSON.stringify(d), " does not have property \"").concat(token, "\""));
            // provide an empty string to avoid translation errors
            d[token] = '';
        }
    });
    return rectifyProps(d);
}
exports.reqArgs = reqArgs;
function rectifyProps(d) {
    var result = {};
    Object.keys(d).forEach(function (key) {
        var _a, _b, _c, _d;
        var value = d[key];
        var key1 = key[0].toUpperCase().concat(key.slice(1));
        var key2 = key[0].toLowerCase().concat(key.slice(1));
        result[key1] = (_b = (_a = value.toString) === null || _a === void 0 ? void 0 : _a.call(value)) !== null && _b !== void 0 ? _b : '';
        result[key2] = (_d = (_c = value.toString) === null || _c === void 0 ? void 0 : _c.call(value)) !== null && _d !== void 0 ? _d : '';
    });
    return result;
}
